import React, { useId, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import Card from "../Card";
import EmailInput from "../Form/EmailInput";
import Button from "../Button";
import Modal from "../../components/Modal";

import useUserStore from "../../store/User.store";

import "./requestPasswordCard.scss";

const RequestPassword = (props) => {
  const handleRequestPassword = useUserStore(
    (state) => state.actions.handleRequestPassword
  );

  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();

  const methods = useForm({
    mode: "onTouched",
  });
  const loginEmailValue = methods.watch("loginEmail");

  const handleRequestPasswordSubmit = async (data) => {
    const res = await handleRequestPassword(data);
    if (res.responseCode === 200) {
      navigate("/reset-password");
    } else {
      setShowModal(true);
    }
  };

  const id = useId();

  return (
    <>
      <FormProvider {...methods}>
        <Card
          {...props}
          id={id}
          className="card--request-password"
          title="Request Password Reset"
          description="Enter your company email to reset your password."
          collapsible={false}
          openByDefault={true}
        >
          <div className="card__content">
            <form
              className="card__request-password-form"
              onSubmit={methods.handleSubmit(handleRequestPasswordSubmit)}
            >
              <EmailInput name={"loginEmail"} label={"Email"} />
              <Button
                size="medium"
                disabled={
                  !loginEmailValue || methods.formState.errors.loginEmail
                }
                className="card__request-password-submit-button"
              >
                Submit
              </Button>
            </form>
          </div>
        </Card>
      </FormProvider>
      <Modal
        show={showModal}
        onClose={() => setShowModal(false)}
        heading="Password Request Unsuccessful"
        subtitle="Please check your company email or contact your administrator."
      />
    </>
  );
};

export default RequestPassword;
